/*
  Cartes de la collection : retournement face / dos au bouton (indispensable
  sur telephone, ou le survol n'existe pas) et legere inclinaison qui suit
  le pointeur sur ordinateur.
*/

class ShowcaseCards extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-showcase-card]'));
    this.cards.forEach((card) => this.setupTurn(card));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    this.cards.forEach((card) => this.setupTilt(card));
  }

  setupTurn(card) {
    const button = card.querySelector('[data-showcase-turn]');
    if (!button) return;

    button.addEventListener('click', () => {
      const flipped = !card.classList.contains('is-flipped');
      card.classList.toggle('is-flipped', flipped);
      button.setAttribute('aria-pressed', flipped ? 'true' : 'false');
      button.textContent = flipped ? button.dataset.labelFront : button.dataset.labelBack;
    });
  }

  // Inclinaison volontairement faible : quelques degres suffisent a donner du relief.
  setupTilt(card) {
    card.addEventListener('pointermove', (event) => {
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      card.classList.add('is-tilting');
      card.style.setProperty('--ry', ((x - 0.5) * 6).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - y) * 5).toFixed(2) + 'deg');
      card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
    });

    card.addEventListener('pointerleave', () => {
      card.classList.remove('is-tilting');
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    });
  }
}

if (!customElements.get('showcase-cards')) {
  customElements.define('showcase-cards', ShowcaseCards);
}
